module.exports = __webpack_public_path__ + "img/hr-V-R-5-unload-standup-shadow.35f2d147.png";